/**
 * The browser's native number-input spinner is glued to the input's own right edge and
 * can't be repositioned, so NumberInput/SliderInput hide it in favor of a separately
 * placed custom stepper button.
 */

export const NUMBER_INPUT_NO_NATIVE_SPIN_CLASS = 'af-number-input-no-native-spin';

const STYLE_ID = 'af-number-input-no-native-spin-styles';

export function ensureNoNativeSpinStyle(): void {
  if (document.getElementById(STYLE_ID)) return;
  const style = document.createElement('style');
  style.id = STYLE_ID;
  style.textContent = `
    .${NUMBER_INPUT_NO_NATIVE_SPIN_CLASS}::-webkit-inner-spin-button,
    .${NUMBER_INPUT_NO_NATIVE_SPIN_CLASS}::-webkit-outer-spin-button {
      -webkit-appearance: none;
      margin: 0;
    }
    .${NUMBER_INPUT_NO_NATIVE_SPIN_CLASS} {
      -moz-appearance: textfield;
    }
  `;
  document.head.appendChild(style);
}
